import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormControl, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/services/common-services/common.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss']
})
export class ForgetPasswordComponent {
  page: number = 1;
  forgotpasswordform!: FormControl;
  formSubmitted = false;
  useremail: any;
  forgotPassword: any;
  base_url = environment.BASE_URL;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private commonServies: CommonService,
    private toastr: ToastrService
  ) {

  }

  ngOnInit() {
    this.forgotpasswordform = this.formBuilder.control('', [
      Validators.required,
      Validators.email
    ]);
  }

  sendLink() {
    this.formSubmitted = true;
    let body = {
      "email": this.forgotpasswordform.value?.toLowerCase(),
      "userType": "Customer"
    }




    let apiurl = `${this.base_url}auth-service/sendResetPasswordMail`;

    this.commonServies.postDatawithoutHeaders(apiurl, body).subscribe({
      next: (data: any) => {
        this.forgotPassword = data;
        this.commonServies.setData(this.forgotpasswordform.value);
        this.router.navigateByUrl('/login/link-sent')
      },
      error: (error: HttpErrorResponse) => {
        this.toastr.error(error.error.status.error.message);
      }
    });


  }

}
